export default __webpack_public_path__ + "static/media/omron.0301be9e.png";